<template>
  <div class="companyRegister">
    <div id="header" class="header">
      <div class="header-main main">
        <span class="logo" @click="$router.replace('/')">
          <img src="@/assets/sp_logo.png" alt="">
        </span>
        <span class="head-title">{{$route.query.type==3?'大客户注册':'企业注册'}}</span>
      </div>
    </div>
    <section class="main">
      <CompanyAuth v-show="current==0" @stepChange="stepChange"/>
      <CompanyInfo v-show="current==1" @stepChange="stepChange"/>
    </section>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {isDev,BASEURL,} from '@/scripts/util.js'
import CompanyAuth from '@/components/companyAuth'
import CompanyInfo from '@/components/companyInfo'
export default {
  name: 'companyRegister',
  components:{
    CompanyAuth,
    CompanyInfo,
  },
  data(){
    return{
      current:0,
    }
  },
  methods: {
    stepChange(step){
      this.current=step;
    }
  },
}
</script>

<style lang="scss">
.companyRegister{
  background-color: #fff;
  padding-top: 110px;
  padding-bottom: 48px;
  #header {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #f75959;
    border-bottom: 1px solid #ccc \0;
    -webkit-box-shadow: 0 0 20px rgba(8,1,3,0.16);
    -moz-box-shadow: 0 0 20px rgba(8,1,3,0.16);
    -o-box-shadow: 0 0 20px rgba(8,1,3,0.16);
    box-shadow: 0 0 20px rgba(8,1,3,0.16);
    .header-main {
      margin: 0 auto;
      height: 68px;
    }
    .header-l {
      float: left;
      overflow: hidden;
    }
    .logo {
      float: left;
      width: 131px;
      height: 37px;
      margin-top: 15px;
    }
    .head-title {
      float: left;
      font-size: 16px;
      color: #333;
      height: 36px;
      line-height: 36px;
      margin-top: 16px;
      margin-left: 10px;
      padding-left: 10px;
    }
  }
  >.main{
    padding: 64px 100px 40px;
    width: 1000px;
    background-color: #f9f9f9;
  }
  .form-item{
    margin-bottom: 20px;
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .label{
    float: left;
    min-width: 100px;
    height: 38px;
    margin-right: 20px;
    font-size: 14px;
    color: #666;
    line-height: 38px;
  }
  .input-box{
    float: left;
    min-width: 500px;
    position: relative;
  }
  .input{
    display: block;
    width: 100%;
    height: 38px;
    border: 1px solid #e5e5e5;
    padding: 5px 10px;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    &:read-only{
      cursor: not-allowed;
      background-color: #f5f5f5;
    }
    &:focus{
      border-color: #f75959;
    }
    &.code-input{
      padding-right: 130px;
    }
  }
  .textarea{
    display: block;
    width: 100%;
    height: 100px;
    border: 1px solid #e5e5e5;
    padding: 5px 10px;
    font-size: 14px;
    color: #333;
    line-height: 22px;
    resize: none;
    &:read-only{
      cursor: not-allowed;
      background-color: #f5f5f5;
    }
    &:focus{
      border-color: #f75959;
    }
    &.code-input{
      padding-right: 130px;
    }
  }
  .btn-code{
    position: absolute;
    right: 0;
    top: 0;
    width: 120px;
    height: 38px;
    background-color: #D5D5D5;
    color: #666;
    font-size: 14px;
    line-height: 38px;
    text-align: center;
    cursor: pointer;
  }
  .btn-default{
    display: inline-block;
    width: 100px;
    height: 38px;
    text-align: center;
    line-height: 36px;
    background-color: #fff;
    border: 1px solid #f75959;
    border-radius: 2px;
    color: #f75959;
    font-size: 14px;
    margin-right: 20px;
  }
  .btn-primary{
    display: inline-block;
    width: 100px;
    height: 38px;
    text-align: center;
    line-height: 38px;
    background-color: #f75959;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
  }
  .agree-deal{
    font-size: 14px;
    .el-checkbox__input{
      vertical-align: middle;
    }
    .el-checkbox__original{
      display: none;
    }
    &.is-checked{
      .el-checkbox__inner{
         background-color: #409eff;
        border-color: #409eff;
        &:after{
          content: "";
          width: 3px;
          height: 7px;
          border-right: 1px solid #fff;
          border-bottom: 1px solid #fff;
          position: absolute;
          left: 4px;
          top: 1px;
          z-index: 2;
          transform: rotate(45deg);
          // transition: transform .15s cubic-bezier(.71,-.46,.88,.6) .05s;
          // transform-origin: center;
          box-sizing: content-box;
        }
      }
    }
    .el-checkbox__inner{
      display: inline-block;
      position: relative;
      border: 1px solid #dcdfe6;
      border-radius: 2px;
      box-sizing: border-box;
      width: 16px;
      height: 16px;
      background-color: #fff;
      z-index: 1;
      transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
      
    }
    .agree{
      color: #333;
      padding-left: 6px;
    }
    .deal{
      color: #f75959;
    }
  }
}
</style>